module.exports = __webpack_public_path__ + "static/img/8.27649d4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/17/zh/8.png
// module id = MYhi
// module chunks = 0